/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs */

const en_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt-to-design pipeline`)
};

const ar_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خط من المحفز إلى التصميم`)
};

const bn_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রম্পট-থেকে-ডিজাইন পাইপলাইন`)
};

const de_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt-zu-Design-Pipeline`)
};

const es_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline de prompt a diseño`)
};

const fr_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline du prompt au design`)
};

const pt_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline de prompt a design`)
};

const zh_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提示词到设计管道`)
};

const tr_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstemden tasarıma hattı`)
};

const ru_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пайплайн от промпта к дизайну`)
};

const pl_svc_ai_image_pod_automation_pipeline_title8 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potok od promptu do projektu`)
};

/**
* | output |
* | --- |
* | "Prompt-to-design pipeline" |
*
* @param {Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_pipeline_title8 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Pipeline_Title8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_pipeline_title8(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_pipeline_title8(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_pipeline_title8(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_pipeline_title8(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_pipeline_title8(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_pipeline_title8(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_pipeline_title8(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_pipeline_title8(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_pipeline_title8(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_pipeline_title8(inputs)
	return en_svc_ai_image_pod_automation_pipeline_title8(inputs)
});
export { svc_ai_image_pod_automation_pipeline_title8 as "svc_ai-image-pod-automation_PIPELINE_title" }